module.exports = __webpack_public_path__ + "img/mind_skeleton_10.2a4c9c0a.png";